<template>
  <div class="main" :class="{collapsed}">
    <div class="left flex-box vertical">
      <div class="logo-img-box">
        <div class="logo-title">国际会议外事通</div>
      </div>
      <menu-bar class="flex-grow"></menu-bar>
    </div>
    <div class="right flex-box vertical" :class="{'left-indent': subMenus}">
      <nav-bar></nav-bar>
      <a-menu class="home-sub-menu" v-model="current" mode="inline" @click="handleClick" v-if="subMenus">
        <component :is="m.children ? 'a-sub-menu' : 'a-menu-item'" v-for="m in subMenus" :key="m.path">
          <template v-if="m.children">
            <span slot="title">{{m.title}}</span>
            <a-menu-item v-for="c in m.children" :key="c.path">{{c.title}}</a-menu-item>
          </template>
          <template v-else>
            <span>{{m.title}}</span>
          </template>
        </component>
      </a-menu>
      <div class="area" :class="{side: subMenus}">
        <router-view></router-view>
      </div>
    </div>
    <img-viewer :list="imgList" :current="currentImg" v-show="viewerShow" @close="hideViewer"></img-viewer>
  </div>
</template>

<script>
import menuBar from '../components/ui/menu-bar'
import navBar from '../components/ui/nav-bar';
import imgViewer from "../components/img-viewer";
export default {
  name: 'Home',
  components: {
    navBar,
    menuBar,
    imgViewer,
  },
  data() {
    return {
      visible: true,
      current: [this.$route.path]
    }
  },
  computed: {
    collapsed () {
      return this.$store.getters.collapsed;
    },
    subMenus() {
      return this.$store.getters.subMenus;
    },
    imgList() {
      return this.$store.getters.imgList;
    },
    currentImg() {
      return this.$store.getters.current;
    },
    viewerShow() {
      return this.$store.getters.viewerShow;
    },
  },
  watch: {
    $route(val) {
      this.current = [val.path];
    },
  },
  methods: {
    hideViewer() {
      this.$store.commit("setViewerShow", false);
    },
    handleClick(e) {
      let path = e.key;
      if(path != this.$route.path) {
        let item = this.subMenus.find(item => item.path == path);
        if(item && item.blank) {
            window.open(path, "_blank");
        } else {
            this.$router.push(path);
        }
      }
    },
  }
}
</script>

<style lang="less">
.left {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 256px;
  box-shadow: 6px 6px 15px rgba(31,81,164,.22);
  z-index: 11;
  transition: all 0.2s;
}
.right {
  position: absolute;
  top: 0;
  left: 256px;
  right: 0;
  bottom: 0;
  background-color: #EDF8FF;
  transition: all 0.2s;
}
.main.collapsed {
  .left {
    width: 80px;
  }
  .right {
    left: 80px;
  }
  .logo-title {
    width: 0;
  }
}
.logo-img-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 60px;
  background-color: #B5D9EF;
  z-index: 1;
  .logo-img {
    width: 32px;
    height: 32px;
    border-radius: 100%;
    object-fit: contain;
  }
  .logo-title {
    font-size: 18px;
    overflow: hidden;
    white-space: nowrap;
    color: #036DB8;
    text-shadow: 0 2px 4px rgba(3, 109, 184, 0.46);
    font-family: Source Han Sans CN;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 2.7px;
  }
}
.home-sub-menu {
  position: absolute;
  top: 60px;
  left: 0;
  bottom: 0;
  width: 188px;
  z-index: 1;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
